import { ApiDateSchema, CurrencySchema } from '@weft/types';
import { oz } from '@weft/utils';

export const MeasurementsStatsSchema = oz.object({
  day: ApiDateSchema,
  customer: oz.string().nonempty(),
  customerExternalId: oz.string().optional(),
  product: oz.string().nonempty(),
  productVariant: oz.string().nonempty(),
  quantity: oz.number().nonnegative(),
  price: oz.number().optional(),
  currency: CurrencySchema.optional(),
  instanceKey: oz.string().optional(),
}).openapi('MeasurementsStats');

export type MeasurementsStats = oz.infer<typeof MeasurementsStatsSchema>;